import { useState, useEffect } from "react";
import getWindow from "../../utils/window";

const IMAGE_CONTAINER_SELECTOR = ".image-container";

function readActiveGalleryIndex(galleryElement: Element): number | null {
  const containers = galleryElement.querySelectorAll(IMAGE_CONTAINER_SELECTOR);

  for (const container of Array.from(containers)) {
    if (container.getAttribute("aria-hidden") !== "true") {
      const index = container.getAttribute("data-gallery-index");
      if (index === null) {
        return null;
      }
      const parsed = Number(index);
      return Number.isFinite(parsed) ? parsed : null;
    }
  }

  return null;
}

export default function useActiveGalleryIndex(
  galleryElement: Element | null,
): number | null {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  useEffect(() => {
    if (!galleryElement) {
      return undefined;
    }

    const update = () => setActiveIndex(readActiveGalleryIndex(galleryElement));

    update();

    const MutationObserver = getWindow().MutationObserver;
    const observer = new MutationObserver(update);
    observer.observe(galleryElement, {
      attributes: true,
      attributeFilter: ["aria-hidden"],
      subtree: true,
    });

    return () => observer.disconnect();
  }, [galleryElement]);

  return activeIndex;
}
